export default __webpack_public_path__ + "static/media/what-1.b8ff9ba2.PNG";